import CurrentSchedule from './template';
export default CurrentSchedule;
